import React from 'react';

const LoadMoreButton = ({ totalCount, displayCount, onLoadMore, className = '' }) => {
  const remainingCount = totalCount - displayCount;

  // 如果没有更多数据或已全部显示，则不渲染按钮
  if (remainingCount <= 0) {
    return null;
  }

  return (
    <div
      className={`mt-[10px] flex cursor-pointer items-center justify-center text-[#444] ${className}`}
      onClick={onLoadMore}
    >
      还有<span className="text-[#0294E7]">{remainingCount}</span>
      个商品未显示，点击
      <span className="mr-[4px] text-[#0294E7]">加载更多</span>
      <span className="mb-[3px] inline-block size-[7px] rotate-[225deg] border-l-[1px] border-t-[1px] border-solid border-[#0294e8]"></span>
    </div>
  );
};

export default LoadMoreButton;
